<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Vendor" title="Raw Material Stock Logs" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-10">
										<div class="mm-cart-text">
											<div class="col-md-6">
												<table class="product_table">
													<thead style="font-size: medium;">
														<tr>
															<th>Vendor Name</th>
															<th style="text-align: left;">:</th>
															<td style="text-align: right;">{{vendorRawMaterial.vendor_name}}</td>
														</tr>
														<tr>
															<th>Raw Material</th>
															<th style="text-align: left;">:</th>
															<td style="text-align: right;">{{vendorRawMaterial.raw_material_name}}</td>
														</tr>
														<tr>
															<th>Current Stock</th>
															<th style="text-align: left;">:</th>
															<td style="text-align: right;">{{vendorRawMaterial.balance_stock}}</td>
														</tr> 
													</thead>
												</table>
											</div>
                                           
                                        </div>
									</div>
                                    <div class="col-md-2">
                                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i
                                                    class='bx bx-chevrons-left'></i> Back</a>
                                    </div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-8 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<!-- <select class="form-control" v-model="listing_length" @change="fetchUsers()"> -->
											<select class="form-select" v-model="listing_length" @change="fetchStockLogs()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Type</th>
											<th>Stock</th>
											<th>Remaining Stock</th>
											<th>Updated On</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(vendorRawMaterialLogs.length)">
                                        <tr align="center" v-for="(material, index) in vendorRawMaterialLogs" :key="material.id">
                                            <td>{{material.id}}</td>
											<td>
												{{ material.type == 1 ? 'Assigned' : material.type == 2 ? 'Used' : material.type == 3 ? 'Deducted' : material.type == 4 ? 'Service' : 'N/A' }} <br>
												<router-link
													v-if="material.service_id"
													:to="{ name: 'complaint_details', params: { id: material.service_id } }"
													class="text-primary"
												>
													Service ID: {{ material.service_id }}
												</router-link>
											</td>
											<td>{{material.stock}}</td>
											<td>{{material.balance_stock}}</td>
											<td>{{$filters.formatDate(material.converted_updated_at)}}</td>
                                        </tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(vendorRawMaterialLogs.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchStockLogs(page.url + '&limit=' + listing_length + '&vendor_id=' + $route.params.vendor_id + '&raw_material_id=' + $route.params.raw_material_id)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

	export default {
		name: "Pincode Page",
		

		data() {
			return {
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},

                button_title: "Save",
                name: "",
				validity: "",
				price: "",

				vendorRawMaterialLogs:[],
				vendorRawMaterial:{},
				
         		// delete: false,
         		// active_page_url: null,
			};
		},
		created() {
			this.fetchStockLogs();
		},
		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			fetchStockLogs(page_url = null) {
				this.getToken();
				const vendorId = this.$route.params.vendor_id || this.$route.query.vendor_id || '';
				const rawMaterialId = this.$route.params.raw_material_id || this.$route.query.raw_material_id || '';
				let url = "/staffs/vendorRawMaterialStockLogs?limit=" + this.listing_length  + "&vendor_id=" + vendorId + "&raw_material_id=" + rawMaterialId;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.vendorRawMaterial = responseData.vendorRawMaterial;
						this.vendorRawMaterialLogs = responseData.vendorRawMaterialLogs.data;
						this.pagination = responseData.vendorRawMaterialLogs.links;
						this.from = responseData.vendorRawMaterialLogs.from;
						this.to = responseData.vendorRawMaterialLogs.to;
						this.total = responseData.vendorRawMaterialLogs.total;
						
					})
					.catch((err) => console.log(err));
			},

			


		},
	};
</script>